import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPumps = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_1436_788)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M19.3594 6.0486L19.3576 6.04776L19.3523 6.04523C19.3455 6.04236 19.3387 6.03963 19.3318 6.03705C19.2975 6.02425 19.2629 6.02708 19.2282 6.02093C19.1942 6.01468 19.1631 6 19.1273 6H14.3773C14.0494 6 13.7835 6.27285 13.7835 6.60938C13.7835 6.94595 14.0494 7.21875 14.3773 7.21875H18.2798L16.2517 12.9426L11.4746 16.8337L7.63848 13.4595C7.44887 13.2925 7.17756 13.2654 6.96008 13.3917L3.37729 15.4698C2.83524 15.7841 2.50005 16.3736 2.5 17.0125C2.49995 17.9914 3.27306 18.7849 4.22674 18.785H4.24472L10.0715 18.7213C10.6709 18.7636 11.2635 18.571 11.7298 18.1822L16.4004 14.3779L17.3635 18.3108C17.4303 18.5815 17.6677 18.7712 17.9398 18.7714H20.3148C20.6425 18.7711 20.9089 18.4983 20.9085 18.1619V12.8126C22.7658 7.60899 19.4606 6.09333 19.3594 6.0486ZM10.1056 17.5039L4.23249 17.5663C4.08671 17.5783 3.94402 17.5189 3.84748 17.4062C3.74475 17.3025 3.68706 17.1607 3.68744 17.0129C3.68759 16.813 3.79235 16.6287 3.96176 16.5302L7.18215 14.6628L10.3996 17.4931C10.3022 17.507 10.2037 17.5105 10.1056 17.5039ZM19.8603 12.1632L17.658 12.5399L19.4242 7.55324C20.0134 8.13049 20.7516 9.46924 19.8603 12.1632ZM18.4025 17.5526L17.4853 13.8052L19.721 13.4225V17.5526H18.4025Z",
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_1436_788",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 19,
			height: 13,
			fill: "white",
			transform: "translate(2.5 6)"
		})
	}) })]
});
export default SvgPumps;
